<script>
export default {
   name: 'CommonLayout',
   props: ['title', 'goBack', 'customClass'],
   computed: {
      getTitle() {
         const queryTitle = this.$route.query.title;
         return queryTitle || this.title;
      },
      isIOS() {
         // Check if the user agent indicates an iOS device
         // return !(/iPhone|iPad|iPod/i.test(navigator.userAgent));
         return false;
      },
      isScanRoute() {
         // Check if the current route is /#/mobile/scan
         return this.$route.path === '/mobile/scan';
      },

      isLoginPage() {
         return this.$route.path === '/ftth/login'
   }
},

}
</script>

<template>
   <div class="main-container">
      <img alt="img" class="img-unitel" src="@/assets/images/img-bg-unitel.svg" />
      <div class="nav-bar js-nav-bar" :class="customClass">
         <div class="nav-bar__inner" :data-ios="isIOS">
            <span class="nav-bar__icon" :data-ios="isIOS" @click="goBack">
               <i class="icon-fonts icon-fonts--chevron-left"></i>
            </span>
            <h3 class="nav-bar__title">{{ getTitle }}</h3>
            <div v-if="$slots.nav">
               <slot name="nav"></slot>
            </div>
            <div v-if="$slots.subAction" class="nav-bar__action">
               <slot name="subAction"></slot>
            </div>
            <!-- <img alt="img" class="img-unitel__child cam-r" src="@/assets/images/bgcam.png" /> -->
            <img alt="img" class="img-unitel__child cam-r" src="@/assets/images/Orange_R.png" />
            <img alt="img" class="img-unitel__child cam-l" src="@/assets/images/Orange_L.png" />

         </div>
      </div>
      <div v-if="$slots.subNav" class="subNav">
         <slot name="subNav"></slot>
      </div>
      <div v-if="$slots.banner" class="banner">
         <slot name="banner"></slot>
      </div>
      <div v-if="$slots.block" class="block">
         <slot name="block"></slot>
      </div>
      <div v-if="$slots.notice" class="notice">
         <slot name="notice"></slot>
      </div>
      <div :class="['content', { 'no-bg': isLoginPage }]" :style="{ background: isScanRoute ? 'transparent' : 'var(--bs-white)' }">
         <slot></slot>
      </div>
   </div>
</template>


<style lang="scss" scoped>
.off {
       -webkit-transform: translateY(-100%) translateZ(0);
    transform: translateY(-100%) translateZ(0);
}
.show {
      transform: translateY(0) translateZ(0);
}
.main-container {
   padding: 0 20px;
   overflow: hidden;
   min-height: 100vh;
   display: flex;
   flex-direction: column;

   .img-unitel {
      position: fixed;
      z-index: -1;
      top: 10px;
      right: 0;
      mix-blend-mode: screen;
   }
   .img-unitel__child {
   //  width: 100%;
    position: absolute;
    bottom: -22px;
   }
   .cam-r {
      right: 0;
      bottom: -26px;
      width: 27px;
   }
   .cam-l {
      left: 0;
      bottom: -26px;
      width: 27px;
   }

   &:after {
      content: '';
      position: fixed;
      top: 0;
      left: 0;
      width: 100vw;
      height: 100%;

      background: linear-gradient(204deg, #fc9d00 0%, #f56e22 19%, #c52305 48%);
      z-index: -2;
   }

   .nav-bar {
      margin: 0;
      position: fixed;
      top: 0;
      left: 0;
      width: 100vw;
      z-index: 100;

      &__inner {
         // background: linear-gradient(204deg, #fc9d00 0%, #f56e22 19%, #c52305 48%);
         // background: linear-gradient(236deg, #fc910d 0%, #f56e22 73%, #e74c0f 115%);
         background-image: url('~@/assets/images/top-header.jpg'); // hoặc dùng đường tương đối
         background-size: cover;
         background-repeat: no-repeat;
         background-position: center top;
         padding: 60px 60px 30px;
         padding: 60px 60px 30px;

         // Adjust padding for iOS devices
         @media screen and (max-width: 768px) {
            &[data-ios="true"] {
               padding: 35px 53px;
            }
         }
      }

      &__icon {
         top: 60px;
         left: 20px;

         // Adjust position for iOS devices
         @media screen and (max-width: 768px) {
            &[data-ios="true"] {
               top: 38px;
               left: 20px;
            }
         }

         i {
            font-weight: 900;
         }
      }

      &__action {
         bottom: 25px;
         right: 20px;
         position: absolute;
      }

      &__title {
         font-weight: bold;
         font-size: 17px;
         line-height: 20px;
      }
   }

   .block {
      padding: 20px;
      background: var(--bs-white);
      border-radius: 20px;
      margin-bottom: 20px;
   }

   .content {
      flex: 1;
      margin: 0 -20px;
      padding-top: 110px; /* Add padding to prevent content from being hidden under fixed nav-bar */
      background: var(--bs-white);
      &.no-bg {
      background: transparent !important;
   }
      border-radius: 30px 30px 0 0;
   }

   .banner {
      margin: 20px -20px;
   }

   .subNav {
      margin-bottom: 30px;
   }
}
</style>